
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Reasons from './components/Reasons';
import Pricing from './components/Pricing';
import BeforeAfter from './components/BeforeAfter';
import Testimonials from './components/Testimonials';
import ServiceArea from './components/ServiceArea';
import CompanyInfo from './components/CompanyInfo';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import FixedContactButtons from '../../components/feature/FixedContactButtons';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <Reasons />
      <Pricing />
      <BeforeAfter />
      <Testimonials />
      <ServiceArea />
      <CompanyInfo />
      <ContactForm />
      <Footer />
      <FixedContactButtons />
    </div>
  );
}
